import {insertThrobber, removeThrobber} from '../Utility/GlobalFunctions';
import {RequestService} from '../RequestService/RequestService';
import AirDatePicker from 'air-datepicker';
import en from 'air-datepicker/locale/en';
import de from 'air-datepicker/locale/de';
export class JobApplicationController {
  private jobForm;
  private uploadInput;
  private files;
  private errorList;
  private divEditUploads;
  private formData;
  private filessize;
  private maxFileText;

  constructor() {
    const jobForm: HTMLElement|null = document.querySelector('.js-jobDetailPage');
    if (jobForm) {
      const language = jobForm.dataset.language;
      new AirDatePicker('#datepicker', {
        startDate: new Date(),
        locale: language === 'de' ? de : en,
      });
      this.uploadInput = document.querySelector('.js-formFile');
      this.jobForm = document.querySelector('.js-jobForm');
      this.errorList = document.createElement('ul');
      this.divEditUploads = document.querySelector('.js-editUploads');
      this.maxFileText = document.querySelector('.js-maxFiles');
      this.filessize = 0;
      this.files = [];
      this.init();
    }
  }

  init() {
    if (this.jobForm) {
      this.jobForm.addEventListener('submit', e => {
        this.formData = new FormData(this.jobForm);
        e.preventDefault();
        if (this.files.length > 0) {
          this.formData.delete('tx_slnrjobs_jobs[jobsForm][file][]');
          for (let i = 0; i < this.files.length; i++) {
            if (this.files[i]) {
              this.formData.append('tx_slnrjobs_jobs[jobsForm][file][' + i + ']', this.files[i]);
            }
          }
          this.submitForm();
        } else {
          this.uploadInput.parentElement.querySelector('.js-error-empty-filed').classList.remove('hidden');
        }
      });
    }

    this.uploadInput.addEventListener('change', e => {
      if (!this.uploadInput.parentElement.querySelector('.js-error-empty-filed').classList.contains('hidden')) {
        this.uploadInput.parentElement.querySelector('.js-error-empty-filed').classList.add('hidden');
      }
      this.uploadInput.parentElement.querySelector('.js-error-empty-filed').classList.add('hidden');
      insertThrobber(this.uploadInput.parentElement);
      const fileLimit = 10485760;
      const uploadedFiles = this.uploadInput.files;
      let filesSize = 0;
      this.errorList.innerHTML = '';
      for (let i = 0; i < uploadedFiles.length; i++) {
        let li = document.createElement('li');
        const litem = document.createElement('li');
        const fileType = uploadedFiles[i].type;
        const acceptedFileType = this.uploadInput.getAttribute('accept').includes(fileType);
        if (uploadedFiles[i].size < fileLimit && this.files.length < 10 && this.filessize + uploadedFiles[i].size < fileLimit && acceptedFileType) {
          this.files.push(uploadedFiles[i]);
          this.filessize = uploadedFiles[i].size + this.filessize;
        } else {
          if (this.files.length > 10) {
            li.appendChild(document.createTextNode(this.maxFileText.text));
            this.errorList.appendChild(li);
          }
          // File type validation
          if (!acceptedFileType) {
            const invalidFileTypeTxt = this.uploadInput.parentElement.dataset.filetype + fileType;
            litem.appendChild(document.createTextNode(invalidFileTypeTxt));
            this.errorList.appendChild(litem);
          }
          // File size validation
          const fileSizeMB = (uploadedFiles[i].size / (1024 * 1024)).toFixed(2);
          const errorTxt = this.uploadInput.parentElement.dataset.maxfilesize1 + fileSizeMB + this.uploadInput.parentElement.dataset.maxfilesize2;
          li.appendChild(document.createTextNode(errorTxt));
          this.errorList.appendChild(li);
        }
      }
      this.uploadInput.value = '';
      removeThrobber();
      this.showUploadedFiles();
      this.showUploadedErrors();
    });
  }

  private async submitForm() {
    insertThrobber(this.jobForm);
    const options = {
      method: this.jobForm.method,
      body: this.formData,
    };
    const data = await new RequestService().getRequestJson(this.jobForm.action, options);
    removeThrobber();
    if (data.errorMessage) {
      const erroDiv = this.jobForm.querySelector('.js-error-email-not-sent');
      erroDiv.insertAdjacentHTML('beforeend', data.errorMessage);
    } else if (data.captchaNotValid) {
      const captchaFailed = this.jobForm.querySelector('.js-error-captcha');
      if (captchaFailed) {
        captchaFailed.insertAdjacentHTML('beforeend', data.captchaNotValid);
        captchaFailed.classList.remove('hidden');
      }
    } else if (data.redirectUrl) {
      window.location.href = data.redirectUrl;
    }
  }

  private removeFile() {
    const removeBtn = document.querySelectorAll('.js-removeFile');
    if (removeBtn) {
      removeBtn.forEach(elem => {
        elem.addEventListener('click', e => {
          if (e.currentTarget instanceof HTMLElement) {
            const id = e.currentTarget.dataset.key;
            this.files.splice(id, 1 );
            this.showUploadedFiles();
          }
        });
      });
    }
  }
  private showUploadedFiles() {
    this.divEditUploads.innerHTML = '';
    for (let i = 0; i < this.files.length; i++) {
      const files = '<label><span class="file file--mime-application-pdf file--application-pdf"> ' + this.files[i].name +
        '</span><span class="js-removeFile form-msg--error" data-key="' + i + '" > ' +  this.uploadInput.parentElement.dataset.removetxt + '</span> </label><br>';
      this.divEditUploads.insertAdjacentHTML('beforeend', files);
    }
    this.removeFile();
  }

  private showUploadedErrors() {
    if (this.errorList.children.length > 0) {
      const divUploadsError = document.createElement('div');
      divUploadsError.classList.add('form-item--error-message');
      divUploadsError.appendChild(this.errorList);
      this.divEditUploads.appendChild(divUploadsError);
    }
  }
}
